// next Month

import { useCalendarContext } from "./context";

// 달력, 날짜 설정
export const useSetMonth = () => {
  const { now, setNow } = useCalendarContext();
  const year = new Date(now).getFullYear();
  const nextMonth = new Date(now.getFullYear(), now.getMonth() + 2, 0);
  const prevMonth = new Date(now.getFullYear(), now.getMonth(), 0);

  const onNextMonth = () => {
    setNow(nextMonth);
  };

  const onPrevMonth = () => {
    setNow(prevMonth);
  };

  const nums = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  const prevMonths = nums.map((num) => {
    return {
      id: -num,
      year: year - num,
    };
  });

  const nextMonths = nums.map((num) => {
    return {
      id: num,
      year: year + num,
    };
  });

  return {
    prevMonths,
    nextMonths,
    onPrevMonth,
    onNextMonth,
  };
};
